import { clsx } from 'clsx';
import * as React from 'react';

import styles from './ChatMessage.css';

interface IChatMessageProps {
  errorSign?: React.ReactNode;
  errorText?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  dataName?: string;
}

export const ChatMessage: React.FC<IChatMessageProps> = ({
  errorSign,
  errorText,
  children: messageBubble,
  className,
  dataName,
}) => {
  return (
    <div className={clsx(styles['message'], className)} data-testid="ChatMessage" data-name={dataName}>
      <div className={styles['message__inner']}>
        {messageBubble}

        <div className={styles['message__error-sign']}>{errorSign}</div>
      </div>

      <div className={styles['message__error-text']}>{errorText}</div>
    </div>
  );
};
